// extracted by mini-css-extract-plugin
export default {"btop":"c5af442c3c _527c1a4c43 _6c346592e7","icon":"_21225786df a2554230ad","btoppink":"ea75b6beec _0320a126a1"};